export const proposedDatesControls = {
  from: 'visitProposalFromDateTime',
  until: 'visitProposalUntilDateTime',
  allDay: 'allDay',
};
